export default {
    title: "Domov",
    button: {
        accessories: "Procházet katalog"
    },
    noAvailableItems: "Portál periferních zařízení v současné době nemá pro vaši zemi k dispozici žádné položky. Ve spolupráci se svým manažerem obstarejte položky, které potřebujete.<br><br> <a href='#' role='button' data-widget-trigger='{widgetOptions}'>Kontaktujte podporu</a>",
    error: "Při načítání produktů došlo k problému. Obnovte prosím svůj prohlížeč."
}